<template>
  <div>
    <form action>
      <!-- CLASS CODE -->
      <div class="form-group row d-flex align-items-end">
        <div class="col-md-8">
          <label
            for="classCode"
            class="class-code color_grey_dark text-uppercase font-weight-bold font-13"
            >Class Code</label
          >
          <input
            type="text"
            id="classCode"
            class="form-control"
            placeholder="Enter class code"
            v-model="code"
          />
        </div>

        <div class="col-md-4">
          <button
            class="btn btn-md btn-accent mx-0"
            @click.prevent="emitAction"
            :disabled="isDisabled"
            ref="verifyBtn"
          >
            VERIY CODE
          </button>
        </div>

        <div class="col-12" v-if="true">
          <div class="add-new-item pointer w-100 mt-3">
            <div class="undone"></div>
            <div
              class="label-text color_ash font-13-5"
              @click="$emit('toggle-invite-form')"
            >
              Don't have a class code?
              <router-link to class="btn-link link-no-underline"
                >Invite your School</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </form>

    <!-- CLASS DISPLAY BLOCK -->
    <div class="row mt-2 mt-md-4" v-if="class_name && school_name">
      <div class="col-md-8 border-gray">
        <div class="class-info-display rounded-5">
          <!-- CLASS -->
          <div class="class font-weight-bold brand_primary">
            {{ class_name }}
          </div>
          <!-- SCHOOL -->
          <div class="school color_grey_dark">@{{ school_name }}</div>
        </div>
      </div>

      <div class="col-md-8 my-2">
        <div v-if="account_type === 'student'"></div>
        <router-link
          to
          class="font-14 option btn-link link-no-underline"
          @click.native="$emit('find-school')"
          >Search for your school</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SetupForm",

  props: {
    show_invite: Boolean,
    class_name: String,
    school_name: String,
  },

  data() {
    return {
      code: "",
      account_type: "",
    };
  },

  mounted() {
    this.getAccountType();
  },

  methods: {
    getAccountType() {
      this.account_type = this.$route.path.split("/")[1];
    },

    emitAction() {
      this.$refs.verifyBtn.innerHTML =
        '<div class="icon-dotted-roller font-17 mr-2 animate"></div>Verifying...';
      this.code = this.code.split(" ").join("");

      setTimeout(() => {
        this.$refs.verifyBtn.innerHTML = "Verify Code";
        this.$emit("classCodeSubmitted", this.code);
      }, 2000);
    },
  },

  computed: {
    isDisabled() {
      if (this.code) return false;
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.class-code {
  @include breakpoint_max(sm) {
    font-size: 12px !important;
  }
  @include breakpoint_max(xs) {
    font-size: 11.5px !important;
  }
}

.label-text {
  @include breakpoint_max(sm) {
    font-size: 12px !important;
  }
}

.class-info-display {
  box-sizing: border-box;
  border: 1px solid $border_grey;
  padding: 15px 15px 8px;

  @include breakpoint_max(sm) {
    padding: 10px 10px 0px;
  }

  .class {
    font-size: 15px;
    line-height: 22px;
    margin-bottom: 4px;

    @include breakpoint_max(md) {
      font-size: 13px;
    }

    @include breakpoint_max(sm) {
      font-size: 12px;
    }
  }

  .school {
    font-size: 14px;
    line-height: 19px;
    margin-bottom: 20px;

    @include breakpoint_max(sm) {
      font-size: 12px;
      margin-bottom: 13px;
    }
  }
}

.option {
  font-size: 14px;
  line-height: 16px;

  @include breakpoint_max(sm) {
    font-size: 12.25px !important;
    line-height: 14px;
    margin-bottom: 10px;
  }
}
</style>
